// extracted by mini-css-extract-plugin
export default {"overflow_container":"OverflowContainer_overflow_container__miq9t"};